import { customerFetch, customerJson } from './customerApi';

export interface CartItem {
  productId: string;
  quantity: number;
  variant?: string;
  price?: number;
}

export interface CartResponse {
  success: boolean;
  data: {
    items: any[];
    total: number;
    itemCount: number;
  };
}

export const cartService = {
  async getCart() {
    return customerJson<CartResponse>('/cart');
  },

  async addToCart(productId: string, quantity: number = 1, variant?: string) {
    return customerJson('/cart', {
      method: 'POST',
      body: JSON.stringify({ productId, quantity, variant }),
    });
  },

  async updateQuantity(itemId: string, quantity: number) {
    return customerJson(`/cart/${itemId}`, {
      method: 'PUT',
      body: JSON.stringify({ quantity }),
    });
  },

  async removeFromCart(itemId: string) {
    return customerJson(`/cart/${itemId}`, { method: 'DELETE' });
  },

  async clearCart() {
    return customerJson('/cart', { method: 'DELETE' });
  },

  async getCartSummary() {
    return customerJson('/cart/summary');
  },
};
